// extracted by mini-css-extract-plugin
export default {"marginCard":"AdministrarConvenio_marginCard__vstlJ"};